import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { useUser } from "../Contexts/UserContext";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const MaterialsGraph = () => {
  const { user } = useUser();
  const [data, setData] = useState([]);
  const { ClientId } = user;
  useEffect(() => {
    const fetchInitData = async () => {
      const api_res = await fetch(
        `${API_URL}/facility/GetRepairMaintenanceData/5/GU-1/${ClientId}/UNTAPS009482`
      );
      const result = await api_res.json();
      if (result.success) {
        setData(result.data);
      } else {
        setData([]);
      }
    };
    fetchInitData();
  }, []);

  const percentageData = data.map((item) => ({
    name: item.label,
    value: item.value,
  }));

  const maxValue = Math.max(...percentageData.map((item) => item.value), 0);

  const renderCustomLabel = ({ x, y, width, value }) => {
    return (
      <text
        x={x + width / 2}
        y={y - 10}
        fill="#000"
        textAnchor="middle"
        fontSize="12"
      >
        {value}
      </text>
    );
  };

  return (
    <div style={{ padding: "20px", position: "relative" }}>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={percentageData}
          margin={{
            top: 5,
            right: 5,
            left: 5,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis domain={[0, maxValue + 50]} />
          <Tooltip />
          <Legend />
          <Bar dataKey="value" fill="#8884d8" barSize={30}>
            <LabelList dataKey="value" content={renderCustomLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div
        style={{
          marginTop: "10px",
          fontSize: "14px",
          fontWeight: "bold",
          position: "absolute",
          bottom: 25,
          left: 100,
        }}
      >
        Materials Status
      </div>
    </div>
  );
};

export default MaterialsGraph;
